// extracted by mini-css-extract-plugin
module.exports = {"FarmProgress":"FarmProgress--2t8L7"};